import { defineMessages } from "react-intl";

export const messages = defineMessages({
    errorTitle: {
        id: "fastshift.migrationSummary.summaryCard.errorTitle",
        defaultMessage: "An Error Occurred",
        description: "Title for the error state in the migration summary card."
    },
    errorDescription: {
        id: "fastshift.migrationSummary.summaryCard.errorDescription",
        defaultMessage: "Refresh the page",
        description:
            "Description for the error state in the migration summary card."
    }
});
